import React from 'react'
import clsx from 'clsx'
import Link from 'next/link'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import ShoppingCart from '@material-ui/icons/ShoppingCart'
import { makeStyles } from '@material-ui/core/styles'

// Local replacement for react-storefront/CartButton.
// A header link to the cart showing the item count in a badge.
const useStyles = makeStyles(
  theme => ({
    link: {},
    badge: {
      border: '2px solid white',
      padding: '0 4px',
    },
    icon: {
      color: theme.palette.action.active,
    },
    wrap: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      ...theme.typography.caption,
    },
  }),
  { name: 'RSFCartButton' },
)

export default function CartButton({
  classes,
  href = '/cart',
  as,
  onClick,
  icon,
  quantity,
  className,
  linkProps = { anchorProps: { 'data-th': 'cart-link' } },
  badgeProps = { color: 'primary' },
  buttonProps = { 'aria-label': 'Cart', color: 'inherit' },
}) {
  classes = useStyles({ classes })
  const cartIcon = icon || <ShoppingCart className={classes.icon} />

  return (
    <Link
      href={href}
      as={as}
      onClick={onClick}
      className={clsx(classes.link, className, linkProps.className)}
      {...linkProps.anchorProps}
    >
      <IconButton {...buttonProps}>
        <div className={classes.wrap} />
        <Badge
          badgeContent={quantity}
          {...badgeProps}
          classes={{ ...badgeProps.classes, badge: classes.badge }}
        >
          {cartIcon}
        </Badge>
      </IconButton>
    </Link>
  )
}
